import React, { useState, useEffect } from "react";
import { Typography, Button, Form, Input } from "antd";
import { RollbackOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import Pageloader from "../../../components/loader";
import { validationErrors } from "../../../utils/Helpers";
import * as actionPage from "../../../redux/actions/cancellationReason.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { Title } = Typography;

const pageName = "Cancellations Reasons";
const pageLink = "cancellationsreasons";

const CancellationsReasonsAdd = (props) => {
  const navigate = useNavigate();
  const params = useParams();
  const { postid } = params;
  const [loading, setLoading] = useState(false);
  const [pageType, setpageType] = useState("add");
  const [postData, setPostData] = useState(null);
  
  useEffect(() => {
    if (postid){
      setpageType("Edit");
      dispacthNoteSingle()
    }
  }, [postid])

  const dispacthNoteSingle = async () => {
    try {
      setLoading(true);
      const {data} = await props.actionPage.findOneAction(postid);
      setPostData(data.data)
    } catch (e) { validationErrors(e) } finally {
      setLoading(false);
    }
  }


  const onFinish = async (values) => {
    try {
      setLoading(true);
      if (pageType === "Edit"){
        await props.actionPage.patchAction(values, postid).then((res)=>{
          if (res.data.code === 200){navigate(`/${pageLink}`)}
        });
      } else {
        await props.actionPage.postAction(values, postid).then((res)=>{
          if (res.data.code === 200){navigate(`/${pageLink}`)}
        });
      }
    } catch (e) { validationErrors(e) } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{pageName} {pageType}</Title>
        <div>
          <Button onClick={() => navigate(`/${pageLink}`)}><RollbackOutlined /></Button>
        </div>
      </div>
      <div className="p-content">
        {loading ? <Pageloader/>:
          <Form onFinish={onFinish} layout="horizontal">
            <Form.Item
              name={["value"]}
              initialValue={postData && postData.value}
              label={pageName}
              rules={[{required: true, message: "Please enter Value"}]}
              >
              <Input />
            </Form.Item>
            <Button className="submit" htmlType="submit">Submit</Button>
          </Form>
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dispactherNoteData: state.DispactherNoteReducer.dispactherNoteData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CancellationsReasonsAdd);
